export const dataHooks = {
  SUFFIX: 'list-item-section-suffix',
  TITLE: 'list-item-section-title',
} as const;

export const TYPES = {
  WHITESPACE: 'whitespace',
  DIVIDER: 'divider',
  TITLE: 'title',
  SUBHEADER: 'subheader',
} as const;
